import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { usePendingCalibrationCount } from '../../../lib/stores/calibration-assignment.store';
import { useLastValueWhere } from '../../../lib/hooks/use-last-value-where';
import { pluralize } from '../../../lib/helpers/text.helpers';
import { IntlMsg } from '../IntlMsg/intl-msg.component';
import { messages } from './calibration-assignments-poller.messages';

interface ICalibrationPendingPromptProps {
  onView: () => void;
  onRemindLater: () => void;
}

// Reads the live pending count itself, so the one enqueued snackbar reflects new counts in
// place — the poller never closes and re-enqueues just to update the displayed number.
export const CalibrationPendingPrompt: React.FC<ICalibrationPendingPromptProps> = ({ onView, onRemindLater }) => {
  const pendingCount = usePendingCalibrationCount();

  // The count hits 0 while the snackbar animates closed (genuine zero, or the sign-out reset);
  // hold the last positive value so a "0 pending" frame never flashes mid-dismissal.
  const displayCount = useLastValueWhere(pendingCount, (count) => count > 0, 1);

  return (
    <Box display="flex" alignItems="center" style={{ gap: '12px' }}>
      <Typography>
        <IntlMsg
          {...messages.pendingPrompt}
          values={{ count: displayCount, assignment: pluralize(displayCount, 'assignment') }}
        />
      </Typography>
      <Button size="small" onClick={onView} style={{ color: '#fff', fontWeight: 'bold' }}>
        <IntlMsg {...messages.btnView} />
      </Button>
      <Button size="small" onClick={onRemindLater} style={{ color: '#fff' }}>
        <IntlMsg {...messages.btnLater} />
      </Button>
    </Box>
  );
};
